export const multilingualLanguagesValues = ['ES', 'EN'];
export const DEFAULT_LANGUAGE = 'EN';
export const ToMultilingualLanguage = (language) => {
    if (!language)
        return DEFAULT_LANGUAGE;
    return language || DEFAULT_LANGUAGE;
};
//# sourceMappingURL=multilingual.interface.js.map